import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { DjayAvatar } from '../../mascot';
import { Clock, Calendar, PlayCircle, BookOpen, Target } from 'lucide-react';
import type { PracticeAssignment } from '../../assessment';
interface PracticeAssignmentBannerProps {
  assignment: PracticeAssignment;
  teacherName: string;
  onStartPractice: () => void;
}
export function PracticeAssignmentBanner({
  assignment,
  teacherName,
  onStartPractice
}: PracticeAssignmentBannerProps) {
  const deadlineStr = assignment.deadline ? new Date(assignment.deadline).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'long'
  }) : null;
  return <Card className="p-3 sm:p-6 border-2 border-indigo-200 shadow-sm bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl relative overflow-hidden" data-id="element-1279">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-1280" />

      <div className="relative z-10 flex flex-row items-center gap-3 sm:gap-6" data-id="element-1281">
        <div className="flex-shrink-0" data-id="element-1282">
          <div className="block sm:hidden" data-id="element-1283">
            <DjayAvatar size="sm" emotion="encouraging" animate data-id="element-1284" />
          </div>
          <div className="hidden sm:block" data-id="element-1285">
            <DjayAvatar size="md" emotion="encouraging" animate data-id="element-1286" />
          </div>
        </div>

        <div className="flex-1 text-left" data-id="element-1287">
          <div className="text-[10px] sm:text-sm font-bold text-indigo-600 uppercase tracking-wider mb-0.5 sm:mb-1" data-id="element-1288">
            Huiswerk van {teacherName}
          </div>
          <h3 className="text-base sm:text-xl font-black text-slate-900 mb-1 sm:mb-2 leading-tight" data-id="element-1289">
            {assignment.title}
          </h3>

          {assignment.note && <p className="text-xs sm:text-sm text-slate-600 italic mb-2" data-id="element-1290">
              "{assignment.note}"
            </p>}

          <div className="flex flex-wrap items-center justify-start gap-2 sm:gap-4 text-xs sm:text-sm font-medium text-slate-600 mb-2 sm:mb-4" data-id="element-1291">
            <div className="flex items-center gap-1 bg-white/60 px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-md border border-indigo-100" data-id="element-1292">
              <Target className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-500" data-id="element-1293" />
              {assignment.moduleIds.length} vakken
            </div>
            {deadlineStr && <div className="flex items-center gap-1 bg-white/60 px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-md border border-indigo-100" data-id="element-1294">
                <Calendar className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-500" data-id="element-1295" />
                Voor {deadlineStr}
              </div>}
          </div>

          <Button onClick={onStartPractice} size="sm" className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm" data-id="element-1296">
            <PlayCircle className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2" data-id="element-1297" />
            Start oefenen
          </Button>
        </div>
      </div>
    </Card>;
}